'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { FormFieldContext } from '../form/form.context.js';
import { Card } from '../card/card.component.js';
import { Spinner } from '../spinner/spinner.component.js';
import { FormError } from '../form/form-error.component.js';
import { Progress } from '../progress-bar/progress.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { Typography } from '../typography/typography.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const FileTile = renderWithRef('FileTile', null, (n, m)=>{
    useComponentStylesLoaded('FileTile', SWAN_STYLE_KEY_MAP.fileTile);
    let { children: u, fileName: b, fileDescription: y, progressValue: d, accessibleTextForProgress: O, accessibleTextForSpinner: j, skin: w = 'standard', layout: _ = 'thumb', errorMessage: h } = n, g = _object_without_properties(n, [
        "children",
        "fileName",
        "fileDescription",
        "progressValue",
        "accessibleTextForProgress",
        "accessibleTextForSpinner",
        "skin",
        "layout",
        "errorMessage"
    ]), P = 'error' === w || h, v = new Set([
        'swan-file-tile',
        `swan-file-tile-skin-${P ? 'error' : w}`,
        `swan-file-tile-layout-${_}`
    ]), x = useContext(FormFieldContext);
    if (P && !x) throw Error('FileTile must be wrapped in FormField with a FileInput when using skin="error"');
    return jsxs(Card, _object_spread_props(_object_spread({
        className: Array.from(v).join(' '),
        ref: m
    }, g), {
        bordered: true,
        children: [
            jsx(Spinner, {
                className: "swan-file-tile-spinner",
                accessibleText: j
            }),
            u,
            jsxs("div", {
                className: "swan-file-tile-details",
                children: [
                    jsx(Typography, {
                        className: "swan-file-tile-name",
                        fontSkin: "title-item",
                        children: b
                    }),
                    jsx(Typography, {
                        className: "swan-file-tile-description",
                        fontSkin: "body-small",
                        textColor: "subtle",
                        children: P ? jsx(FormError, {
                            as: "div",
                            children: h
                        }) : 'queued' === w ? j : y
                    }),
                    jsx("div", {
                        className: "swan-file-tile-progress-container",
                        children: jsx(Progress, {
                            value: null != d ? d : 0,
                            "aria-label": O
                        })
                    })
                ]
            })
        ]
    }));
});

export { FileTile };
